module.exports = __webpack_public_path__ + "static/media/Daniel Pack.7248cacd.jpg";